<template>
	<table>
		<caption>Consignment Item Summary</caption>
		<thead>
			<tr>
				<th>Items</th>
				<th>Weight</th>
				<th>Volume</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ noItems }}</td>
				<td>{{ weight }}</td>
				<td>{{ volume }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: {
			noItems: Number,
			weight: Number,
			volume: Number
		}
	}
</script>